import axios, { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

import { handBookActions } from "../model/slice";
import { ImportDocumentation, getContentDispositionFileName } from "widgets/ImportDocumentation";

const formatSampleFileName = (response: AxiosResponse) => {
  const defaultFileName = getContentDispositionFileName(response);
  const extension = defaultFileName.split(".").at(-1);
  return `Шаблон.${extension}`;
};

const removeFileExtension = (name: string) => name.replace(/\.[^/.]+$/, "");

const ImportTemplateDocumentation = () => {
  const dispatch = useDispatch();
  return (
    <ImportDocumentation
      refresh={() => dispatch(handBookActions.invalidateKey())}
      formatSampleFileName={formatSampleFileName}
      downloadSampleRequest={() => axios.post(`/help/templates/import/template/`, {}, { responseType: "blob" })}
      uploadDocumentationRequest={({ name, file }) =>
        axios.post(`/help/templates/import/`, {
          name,
          file,
          template_name: removeFileExtension(name),
        })
      }
    />
  );
};
export default ImportTemplateDocumentation;
